/**
 * Created by mac on 12/23/20
 */

const EditorViewFactory = function (component, unitView) {
    let componentView;
    let x = unitView.width / 2, y = unitView.height / 2;
    let zOrder = 0;

    if (component instanceof Grounded) {
        componentView = new GroundedView(component, unitView);
        x = unitView.width * unitView.anchorX;
        y = unitView.height * unitView.anchorY;
        zOrder = -1;
    } else if (component instanceof MultiCell) {
        MultiCellView(component.unit, unitView);
    } else if (component instanceof LockedComponent) {
        componentView = new LockedComponentView(component, unitView);
    } else if (component instanceof Multiple) {
        componentView = new MultipleView(component, unitView);
    }

    if (componentView instanceof cc.Node) {
        componentView.setAlignment(x, y);
        componentView.setAnchorPoint(0.5, 0.5);
        unitView.addChild(componentView, zOrder);
    }

    if (componentView) {
        component.setView(componentView);
    }
};